// extracted by mini-css-extract-plugin
export var container = "player_list-module--container--3xgbP";
export var entry = "player_list-module--entry--iuGbK";
export var playerName = "player_list-module--playerName--KHeOd";
export var text = "player_list-module--text--KcCQy";